module.exports = __webpack_public_path__ + "img/green-pita-07.c84c5bc0.png";